import {request,post,get} from '@/plugins/requestU'

/**
 * 根据agentWebUrl获取agent信息
 * @param {*} data 
 * @returns 
 */
export function uasSendSMSCode(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/sendSmsCode', data);
}
/**
 * 注册
 * @param {} data 
 * @returns 
 */
export function uasReg(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/reg', data);
}
/**
 * 登录
 * @param {} data 
 * @returns 
 */
export function uasLogin(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/login', data);
}

/**
 * 重置密码
 * @param {} data 
 * @returns 
 */
export function uasResetPwd(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/resetPwd', data);
}